<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.83 8.01002L14.28 2.77002C13 1.75002 11 1.74002 9.72996 2.76002L3.17996 8.01002C2.23996 8.76002 1.66996 10.26 1.86996 11.44L3.12996 18.98C3.41996 20.67 4.98996 22 6.69996 22H17.3C18.99 22 20.59 20.64 20.88 18.97L22.14 11.43C22.32 10.26 21.75 8.76002 20.83 8.01002ZM12.75 18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18Z" fill="url(#paint0_linear_8699_27945)" />
    <defs>
      <linearGradient id="paint0_linear_8699_27945" x1="-1.40791" y1="-14.8056" x2="32.0823" y2="-8.6348" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
